import { render } from "./userprofile.vue?vue&type=template&id=105175ee&scoped=true"
import script from "./userprofile.vue?vue&type=script&lang=js"
export * from "./userprofile.vue?vue&type=script&lang=js"

import "./userprofile.vue?vue&type=style&index=0&id=105175ee&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105175ee"]])

export default __exports__